import { createSlice } from '@reduxjs/toolkit';

const features = createSlice({
  name: 'FEATURES',
  initialState: {},

  reducers: {
    setIsBounceNavigationAnimationEnabled: (state, action) => {
      state.isBounceNavigationAnimationEnabled =
        action.payload.isBounceNavigationAnimationEnabled;
    },
  },
});

const { actions } = features;

export const { setIsBounceNavigationAnimationEnabled } = actions;

export default features.reducer;
